import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { baseUrls } from '../appConstant';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  public updatingUserDataOnEdit = new Subject<any>();
  baseUrls = baseUrls;
  constructor(
    private httpClient: HttpClient
  ) { }

  // CREATE
  postCreateAddress(dataPassed){
    if(dataPassed){
      return this.httpClient?.post(this.baseUrls?.user + "addressinfo/create", dataPassed);
    }
  }
  
  // GET
  postAddressesForAddressList(startPassed , lengthPassed, userIdPassed){
    if(startPassed >= 0 && lengthPassed && userIdPassed){
      return this.httpClient?.post(this.baseUrls?.user + "addressinfo",
      {start: startPassed, length: lengthPassed, userId: userIdPassed}
      );
    }
  }
  
  // EDIT
  putEditAddresses(dataPassed, addressIdPassed){
    if(dataPassed && addressIdPassed){
      return this.httpClient?.put(this.baseUrls?.user + `addressinfo/update/${addressIdPassed}`,dataPassed);
    }
  }
// DELETE
  deleteAddresses( addressIdPassed){
    if(addressIdPassed){
      return this.httpClient?.delete(this.baseUrls?.user + `addressinfo/delete/${addressIdPassed}`);
    }
  }

  updatingUserDataOnEditSubject(addressInfo){
    this.updatingUserDataOnEdit?.next(addressInfo);
  }
}
